import React from "react";

import { Presenter } from "./Presenter";

import { Props } from "../../types/Heading01";

export const Heading01: React.VFC<Props> = (props) => {
  return <Presenter {...props} />;
};
